export default __webpack_public_path__ + "static/media/p3p.d00b0dff.png";